import { getPriceBillingConfig } from '@repo/checkout';
import { firstActivePrice } from '@dashboard/services/getActivePrices';

/**
 * if the product has a trial and a setup fee, it's a paid trial
 * if the product has a trial and no setup fee, it's a free trial
 * if the product does not have a trial, it's false
 */
export function getTrial(product) {
  const price = firstActivePrice(product);
  // TODO(M14): legacy product-scalar fallback — remove once the prices[] backfill migration has run (product.trialPeriodDays/setupFee)
  const trialPeriodDays = price ? getPriceBillingConfig(price)?.trialPeriodDays : product.trialPeriodDays;
  const setupFee = price ? price.setupFee : product.setupFee;

  if (trialPeriodDays) {
    return setupFee ? 'paid' : 'free';
  }

  return '';
}
